interface DateRangePickerProps {
  startDate: string
  endDate: string
  onStartDateChange: (value: string) => void
  onEndDateChange: (value: string) => void
  idPrefix: string
  label?: string
}

// Shared start/end date filter used by report sections that accept optional
// start_date/end_date query params. Both fields are optional -- clearing
// both (or never setting them) means "all time", matching how the backend
// treats missing params.
export default function DateRangePicker({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  idPrefix,
  label,
}: DateRangePickerProps) {
  const hasFilter = !!startDate || !!endDate

  return (
    <div className="flex flex-wrap items-end gap-3">
      {label && (
        <span className="text-sm text-espresso-600 mb-2 sm:mb-0 sm:self-center">{label}</span>
      )}
      <div>
        <label htmlFor={`${idPrefix}-start`} className="block text-xs font-medium text-espresso-600 mb-1">
          Desde
        </label>
        <input
          id={`${idPrefix}-start`}
          type="date"
          value={startDate}
          max={endDate || undefined}
          onChange={(e) => onStartDateChange(e.target.value)}
          className="border border-espresso-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500"
        />
      </div>
      <div>
        <label htmlFor={`${idPrefix}-end`} className="block text-xs font-medium text-espresso-600 mb-1">
          Hasta
        </label>
        <input
          id={`${idPrefix}-end`}
          type="date"
          value={endDate}
          min={startDate || undefined}
          onChange={(e) => onEndDateChange(e.target.value)}
          className="border border-espresso-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta-500"
        />
      </div>
      {hasFilter && (
        <button
          type="button"
          onClick={() => {
            onStartDateChange('')
            onEndDateChange('')
          }}
          className="text-sm text-terracotta-700 hover:text-terracotta-800 underline underline-offset-2 pb-2"
        >
          Ver todo el histórico
        </button>
      )}
    </div>
  )
}
